var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quote-type2"},[_c('div',{staticClass:"quote-type2__quote"},[_vm._t("default")],2),_vm._v(" "),(this.$slots.author)?_c('div',{staticClass:"quote-type2__author"},[_vm._t("author")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }